module.exports = __webpack_public_path__ + "img/Austria.604f3bae.png";